// AXIOS状态：开始、结束、重置
export const AXIOS_START = 'axiosStart'
export const AXIOS_END = 'axiosEnd'
export const AXIOS_RESET = 'axiosReset'

// 会话TOKEN：保存、清除
export const SAVE_TOKEN = 'saveToken'
export const CLEAR_TOKEN = 'clearToken'

// 保存用户信息
export const SAVE_USERINFO = 'saveUserInfo'

// 保存文章信息：分类列表、指定分类文章列表
export const SAVE_CATEGORIES = 'saveCategories'
export const SAVE_ARTICLES = 'saveArticles'